import React, { useState } from 'react';
import './LibraryHolding.css';
import Navbar from '../components/navbar';
import CTAButton from '../components/sticky-button';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';

const BooksIcon = () => (
  <svg className="lib-dash-stat-svg" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5v-16Z" />
    <path d="M4 5.5A2.5 2.5 0 0 1 6.5 8H20" />
    <path d="M8 3v16" />
  </svg>
);

const AddTitleIcon = () => (
  <svg className="lib-dash-stat-svg" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M6.5 4.5h8L18 8v11.5H6.5v-15Z" />
    <path d="M14.5 4.5V8H18" />
    <path d="M12 11v5" />
    <path d="M9.5 13.5h5" />
  </svg>
);

const GlobeJournalIcon = () => (
  <svg className="lib-dash-stat-svg" viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" />
    <path d="M3.8 12h16.4" />
    <path d="M12 3.5c2.2 2.4 3.2 5.1 3.2 8.5s-1 6.1-3.2 8.5" />
    <path d="M12 3.5C9.8 5.9 8.8 8.6 8.8 12s1 6.1 3.2 8.5" />
  </svg>
);

const TrendUpIcon = () => (
  <svg className="lib-dash-trend-svg" viewBox="0 0 24 24" aria-hidden="true">
    <path d="m5 16 5-5 3.5 3.5L19 9" />
    <path d="M14 9h5v5" />
  </svg>
);

const LibraryHolding = () => {
  const [activeTab, setActiveTab] = useState('growth');
  const [journalSearch, setJournalSearch] = useState('');
  const [accordionOpen, setAccordionOpen] = useState({
    current: true,
    archivedNat: false,
    archivedInt: false
  });

  const toggleAccordion = (section) => {
    setAccordionOpen(prev => ({ ...prev, [section]: !prev[section] }));
  };

  // --- DATA SOURCES ---

  // 1. Volume Growth Data (2001 - 2026) - UPDATED with full year format
  const volumeGrowthData = [
    { year: '2001-2002', vol: 615 }, 
    { year: '2002-2003', vol: 1905 }, 
    { year: '2003-2004', vol: 2160 },
    { year: '2004-2005', vol: 2396 }, 
    { year: '2005-2006', vol: 2663 }, 
    { year: '2006-2007', vol: 3003 },
    { year: '2007-2008', vol: 3115 }, 
    { year: '2008-2009', vol: 3257 }, 
    { year: '2009-2010', vol: 3773 },
    { year: '2010-2011', vol: 5571 }, 
    { year: '2011-2012', vol: 7067 }, 
    { year: '2012-2013', vol: 8079 },
    { year: '2013-2014', vol: 9153 }, 
    { year: '2014-2015', vol: 10155 }, 
    { year: '2015-2016', vol: 11082 },
    { year: '2016-2017', vol: 12082 }, 
    { year: '2017-2018', vol: 12583 }, 
    { year: '2018-2019', vol: 12834 },
    { year: '2019-2020', vol: 12960 }, 
    { year: '2020-2021', vol: 13233 }, 
    { year: '2021-2022', vol: 13349 },
    { year: '2022-2023', vol: 13461 }, 
    { year: '2023-2024', vol: 13483 }, 
    { year: '2024-2025', vol: 13678 },
    { year: '2025-2026', vol: 13760 }
  ];

  // 2. Titles Added (Full History 2013 - 2026)
  const titlesAddedData = [
    { range: 'Jun 13 - May 14', titles: 312, vols: 1074 },
    { range: 'Jun 14 - May 15', titles: 139, vols: 1002 },
    { range: 'Jun 15 - May 16', titles: 74, vols: 927 },
    { range: 'Jun 16 - May 17', titles: 151, vols: 1000 },
    { range: 'Jun 17 - May 18', titles: 111, vols: 501 },
    { range: 'Jun 18 - May 19', titles: 81, vols: 251 },
    { range: 'Jun 19 - May 20', titles: 125, vols: 126 },
    { range: 'Jul 20 - Jun 21', titles: 93, vols: 273 },
    { range: 'Jul 21 - Jun 22', titles: 25, vols: 116 },
    { range: 'Jul 22 - Jun 23', titles: 41, vols: 112 },
    { range: 'Jul 23 - Jun 24', titles: 12, vols: 22 },
    { range: 'Jul 24 - Jun 25', titles: 73, vols: 195 },
    { range: 'Jul 25 - Jun 26', titles: 55, vols: 82 },
  ];

  // 3. Journals Added (Year Wise History)
  const journalsAddedData = [
    { year: '2015', details: '24 (National Printed) + 161 IEEE ASPP & DLINE Online', mags: 3 },
    { year: '2016', details: '24 (National Printed) + 169 IEEE ASPP & DLINE Online', mags: 3 },
    { year: '2017', details: '24 (National Printed) + 169 IEEE ASPP & DLINE Online', mags: 3 },
    { year: '2018', details: '24 (National Printed) + 179 IEEE ASPP & DLINE Online', mags: 3 },
    { year: '2019', details: '12 (National Printed) + 12 (International Printed) + 183 IEEE ASPP e-journal Online', mags: 3 },
    { year: '2020', details: '12 (National Printed) + 12 (International Printed) + 190 IEEE ASPP e-journal Online', mags: 3 },
    { year: '2021', details: '18 (National Printed) + 18 (International Printed) + 190 IEEE ASPP e-journal Online', mags: 3 },
    { year: '2022', details: '18 (National Printed) + 18 (International Printed) + 190 IEEE ASPP e-journal Online', mags: 3 },
    { year: '2023', details: '18 (National Printed) + 18 (International Printed) + 190 IEEE ASPP e-journal Online', mags: 3 },
    { year: '2024', details: '6 (National / International Printed) + 190 IEEE ASPP e-journal Online', mags: 3 },
    { year: '2025', details: '6 (National / International Printed) + 190 IEEE ASPP e-journal Online', mags: 3 },
    { year: '2026', details: '6 (National / International Printed) + 103 Springer Nature 1 Computer Science (e-journals) Online', mags: 3 },
  ];

  // 4. Current Journals (2026)
  const currentJournals = [
    { name: "Computer Science and Information Systems", freq: "Q" },
    { name: "IAENG International Journal of Computer Science", freq: "Q" },
    { name: "International Journal of Applied Mathematics and Computer Science", freq: "Q" },
    { name: "International Journal of Computer Information Systems & Industrial Management Applications", freq: "Q" },
    { name: "Journal of Information and Communication Technology (JICT)", freq: "Q" },
    { name: "ICTACT Journal on Soft Computing (IJSC)", freq: "Q" }
  ];

  const nationalJournals2023 = [
    { name: "Current Development in Artificial Intelligence", freq: "Bi-A" },
    { name: "Journal of Advance Research in Computer Engineering", freq: "Q" },
    { name: "Journal of Analysis and Computation ugc approved", freq: "Q" },
    { name: "Journal of Computer Science and Applications", freq: "Bi-A" },
    { name: "Journal of Intelligent Computing & Application", freq: "Bi-A" },
    { name: "Journal of Neural Computing Systems", freq: "Bi-A" },
    { name: "Journal of Software Engineering & Technology", freq: "Bi-A" },
    { name: "Journal of the Business Strategy", freq: "Q" },
    { name: "Journal of Software Project Mgt & Quality Assurance", freq: "Bi-A" },
    { name: "Indian Journal of Advances in wireless & mobile Communication (GRP)", freq: "Bi-A" },
    { name: "Indian Journal of computers & Applications (GRP)", freq: "Q" },
    { name: "Indian Journal of Software Engineering (GRP)", freq: "Q" },
    { name: "Journal of Network Security Computer Networks", freq: "Q" },
    { name: "Journal of Data Mining and Management", freq: "Bi-A" },
    { name: "Journal of Information Technology and Sciences", freq: "Q" },
    { name: "Global Journal of Networks and Applications", freq: "Bi-A" },
    { name: "Journal of Advances in Computational Sciences & Information Technology", freq: "Bi-A" },
    { name: "Journal of Information Technology and Education System", freq: "Bi-A" }
  ];

  const internationalJournals2023 = [
    { name: "International Journal of Advance Computational Engineering & Networking", freq: "Q" },
    { name: "International Journal of Advanced Computer Engineering", freq: "Bi-A" },
    { name: "International Journal of Advances in Computer Science & Cloud Computing", freq: "Q" },
    { name: "International Journal of Business Management & Information Technology", freq: "Q" },
    { name: "International Journal of Cloud Computing and Data Base Management", freq: "Bi-A" },
    { name: "International Journal of Computer Engineering & Software Technology", freq: "Bi-A" },
    { name: "International Journal of Data Analysis & Information System", freq: "Bi-A" },
    { name: "International Journal of Data Warehousing", freq: "Bi-A" },
    { name: "International Journal of Engineering in Computer Science", freq: "Bi-A" },
    { name: "International Journal of Future Generation Communication and Networking", freq: "Q" },
    { name: "International Journal of Knowledge Mgt & E- Learning", freq: "Bi-A" },
    { name: "International Journal of Neural Networks & Applications", freq: "Bi-A" },
    { name: "International Journal of Recent Technology and Engineering – Scopus", freq: "Q" },
    { name: "International Journal of Research in IT, Management & Engineering", freq: "Q" },
    { name: "International Journal of Soft Computing And Artificial Intelligence", freq: "Q" },
    { name: "International Journal of Software Engineering & Systems", freq: "Q" },
    { name: "International Journal of Web application (IJWA) dline", freq: "Bi-A" },
    { name: "International Journal of Wireless Communications & Networking", freq: "Bi-A" }
  ];

  const filterJournals = (journals) => {
    const query = journalSearch.trim().toLowerCase();
    if (!query) return journals;

    return journals.filter((journal) =>
      `${journal.name} ${journal.freq}`.toLowerCase().includes(query)
    );
  };

  const renderJournalTable = (journals) => {
    const filteredJournals = filterJournals(journals);

    return (
      <div className="table-container lib-dash-repo-table-wrap">
        <table className="responsive-table">
          <thead>
            <tr>
              <th style={{ width: '70px' }}>Sr. No.</th>
              <th>Journal Name</th>
              <th style={{ width: '120px' }}>Frequency</th>
            </tr>
          </thead>
          <tbody>
            {filteredJournals.map((journal, index) => (
              <tr key={`${journal.name}-${index}`}>
                <td>{String(index + 1).padStart(2, '0')}</td>
                <td>{journal.name}</td>
                <td><span className="lib-dash-freq-badge">{journal.freq}</span></td>
              </tr>
            ))}
            {filteredJournals.length === 0 && (
              <tr>
                <td colSpan="3" className="lib-dash-empty-cell">No journals found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };

return (
    <>
      <Navbar />
      <CTAButton />
      
      <div className="lib-dash-container">
        <PageHeader
          title="TIMSCDR Library Holding"
          crumbs={[{ label: "Home", href: "/" }, { label: "TIMSCDR Library Holding" }]}
        />

        {/* Top Stats Cards */}
        <div className="lib-dash-stats-grid">
          <div className="lib-dash-stat-card">
            <div className="lib-dash-stat-icon"><BooksIcon /></div>
            <div className="lib-dash-stat-header">Total Volumes</div>
            <div className="lib-dash-stat-body">
              <div className="lib-dash-stat-value">
                13,760
                <span className="lib-dash-trend-icon"><TrendUpIcon /></span>
              </div>
              <div className="lib-dash-stat-sub">From 615 in 2001</div>
            </div>
          </div>
          <div className="lib-dash-stat-card">
            <div className="lib-dash-stat-icon"><AddTitleIcon /></div>
            <div className="lib-dash-stat-header">Titles Added</div>
            <div className="lib-dash-stat-body">
              <div className="lib-dash-stat-value">55</div>
              <div className="lib-dash-stat-sub">82 New Volumes Added</div>
            </div>
          </div>
          <div className="lib-dash-stat-card">
            <div className="lib-dash-stat-icon"><GlobeJournalIcon /></div>
            <div className="lib-dash-stat-header">Active Journals</div>
            <div className="lib-dash-stat-body">
              <div className="lib-dash-stat-value">109+</div>
              <div className="lib-dash-stat-sub">103 Online (Springer Nature) + 6 Print</div>
            </div>
          </div>
        </div>

        {/* Charts Section */}
        <div className="lib-dash-charts-grid" id="growth">
          
          {/* Growth Trend Chart */}
          <div className="lib-dash-chart-card">
            <div className="lib-dash-chart-title">Library Growth Trend</div>
            <p className="lib-dash-chart-desc">Cumulative volume growth from 2001-2026.</p>
            <div className="lib-dash-growth-chart-image-container">
              <img 
                src="/images/Library/bookdata.png" 
                alt="Year wise Growth of Books Bar Chart" 
                className="lib-dash-growth-image"
              />
            </div>
          </div>

          {/* Recent Additions Bar Chart (Last 5 Years) */}
          <div className="lib-dash-chart-card">
            <div className="lib-dash-chart-title">Additions</div>
            <p className="lib-dash-chart-desc">Titles and volumes added in the last five years.</p>
            <div className="lib-dash-legend">
                <div><span className="lib-dash-dot blue"></span>Titles</div>
                <div><span className="lib-dash-dot orange"></span>Volumes</div>
            </div>
            <div className="lib-dash-bar-container">
              {titlesAddedData.slice(-5).map((item, index) => {
                const tH = Math.max(item.titles * 0.5, 4); 
                const vH = Math.max(item.vols * 0.5, 4);
                return (
                  <div key={index} className="lib-dash-bar-group">
                    <div className="lib-dash-bar-wrapper">
                      <div className="lib-dash-bar blue" style={{height: `${tH}px`}} title={`Titles: ${item.titles}`}></div>
                      <div className="lib-dash-bar orange" style={{height: `${vH}px`}} title={`Volumes: ${item.vols}`}></div>
                    </div>
                    <span className="lib-dash-bar-label">{item.range.split('-')[1].trim()}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Collection Mix Donut */}
          <div className="lib-dash-chart-card" id="journals">
            <div className="lib-dash-chart-title">Journal Mix</div>
            <p className="lib-dash-chart-desc">2026 split between print and online resources.</p>
            <div className="lib-dash-donut-wrapper">
              <div className="lib-dash-donut">
                <div className="lib-dash-donut-inner">
                   <span className="lib-dash-donut-stat">109</span>
                   <span className="lib-dash-donut-label">Total</span>
                </div>
              </div>
              <div className="lib-dash-donut-legend">
                <div className="lib-dash-legend-row">
                  <span><span className="lib-dash-dot orange"></span> Printed</span>
                  <strong>6</strong>
                </div>
                <div className="lib-dash-legend-row">
                  <span><span className="lib-dash-dot blue"></span> Online/Springer Nature</span>
                  <strong>103</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs / Data Table Section */}
        <div className="lib-dash-tabs-container">
          <div className="lib-dash-tab-header">
            <button 
              className={`lib-dash-tab-btn ${activeTab === 'growth' ? 'active' : ''}`}
              onClick={() => setActiveTab('growth')}
            >
              LIBRARY GROWTH
            </button>
            <button 
              className={`lib-dash-tab-btn ${activeTab === 'titles' ? 'active' : ''}`}
              onClick={() => setActiveTab('titles')}
            >
              TITLES ADDED
            </button>
            <button 
              className={`lib-dash-tab-btn ${activeTab === 'journals' ? 'active' : ''}`}
              onClick={() => setActiveTab('journals')}
            >
              JOURNAL STATISTICS
            </button>
          </div>
          
          <div className="lib-dash-tab-content">
            {/* Tab 1: Volume Growth */}
            {activeTab === 'growth' && (
              <div className="table-container">
                <table className="responsive-table">
                  <thead>
                    <tr>
                      <th>Year</th>
                      <th>No. of Volumes</th>
                      <th>Cumulative Progress</th>
                    </tr>
                  </thead>
                  <tbody>
                    {volumeGrowthData.slice().reverse().map((row, i) => {
                        const width = `${(row.vol / 13760) * 100}%`;
                        return (
                        <tr key={i}>
                          <td>{row.year}</td>
                          <td>{row.vol.toLocaleString()}</td>
                          <td>
                            <div className="lib-dash-progress-track">
                              <div className="lib-dash-progress-bar" style={{width: width}}></div>
                            </div>
                          </td>
                        </tr>
                        );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {/* Tab 2: Titles Added */}
            {activeTab === 'titles' && (
               <div className="table-container">
                  <table className="responsive-table">
                  <thead>
                  <tr>
                      <th>Year Range</th>
                      <th>Titles Added</th>
                      <th>Volumes Added</th>
                  </tr>
                  </thead>
                  <tbody>
                  {titlesAddedData.slice().reverse().map((row, i) => (
                      <tr key={i}>
                      <td>{row.range}</td>
                      <td>{row.titles}</td>
                      <td>{row.vols}</td>
                      </tr>
                  ))}
                  </tbody>
                  </table>
              </div>
            )}

            {/* Tab 3: Journals Added (NEW) */}
            {activeTab === 'journals' && (
               <div className="table-container">
                  <table className="responsive-table journal-data-table">
                  <thead>
                  <tr>
                      <th style={{width: '100px'}}>Year</th>
                      <th>Journals Description</th>
                      <th style={{width: '100px'}}>Magazines</th>
                  </tr>
                  </thead>
                  <tbody>
                  {journalsAddedData.slice().reverse().map((row, i) => (
                      <tr key={i}>
                      <td style={{fontWeight: '600', color: '#1e3a8a'}}>{row.year}</td>
                      <td>{row.details}</td>
                      <td>{row.mags}</td>
                      </tr>
                  ))}
                  </tbody>
                  </table>
              </div>
            )}
          </div>
        </div>

        {/* Journal Repository Accordion */}
        <section className="lib-dash-accordion-section" id="repository">
          {/* UPDATED: Changed from h3 to div */}
          <div className="lib-dash-repo-head">
            <div>
              <div className="lib-dash-repo-title">Journal Repository</div>
              <p>Search and review active and archived journal subscriptions.</p>
            </div>
            <label className="lib-dash-search">
              <span>Search Journal</span>
              <input
                type="search"
                value={journalSearch}
                onChange={(event) => setJournalSearch(event.target.value)}
                placeholder="Search Journal..."
              />
            </label>
          </div>
          
          {/* Accordion Item 1: List of National / International Journals 2026 */}
          <div className="lib-dash-acc-item">
            <button 
              className={`lib-dash-acc-header ${accordionOpen.current ? 'active' : ''}`}
              onClick={() => toggleAccordion('current')}
            >
              <span>List of National / International Journals (2026)</span>
              <div className="lib-dash-acc-meta">
                  <span className="lib-dash-badge">{filterJournals(currentJournals).length}</span>
                  {/* SVG Dropdown Icon */}
                  <svg 
                    className={`lib-dash-chevron ${accordionOpen.current ? 'open' : ''}`}
                    width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
              </div>
            </button>
            
            {accordionOpen.current && (
              <div className="lib-dash-acc-content">
                {renderJournalTable(currentJournals)}
                <div className="lib-dash-frequency-note">
                  Frequency Legend: Q = Quarterly | Bi-A = Bi-Annual | M = Monthly
                </div>
              </div>
            )}
          </div>

          {/* Accordion Item 2: National 2023 */}
          <div className="lib-dash-acc-item">
            <button 
              className={`lib-dash-acc-header ${accordionOpen.archivedNat ? 'active' : ''}`}
              onClick={() => toggleAccordion('archivedNat')}
            >
              <span>Archived National Journals (2023)</span>
              <div className="lib-dash-acc-meta">
                  <span className="lib-dash-badge">{filterJournals(nationalJournals2023).length}</span>
                  {/* SVG Dropdown Icon */}
                  <svg 
                    className={`lib-dash-chevron ${accordionOpen.archivedNat ? 'open' : ''}`}
                    width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
              </div>
            </button>
            
            {accordionOpen.archivedNat && (
              <div className="lib-dash-acc-content">
                {renderJournalTable(nationalJournals2023)}
              </div>
            )}
          </div>

           {/* Accordion Item 3: International 2023 */}
           <div className="lib-dash-acc-item">
            <button 
               className={`lib-dash-acc-header ${accordionOpen.archivedInt ? 'active' : ''}`}
              onClick={() => toggleAccordion('archivedInt')}
            >
              <span>Archived International Journals (2023)</span>
              <div className="lib-dash-acc-meta">
                  <span className="lib-dash-badge">{filterJournals(internationalJournals2023).length}</span>
                  {/* SVG Dropdown Icon */}
                  <svg 
                    className={`lib-dash-chevron ${accordionOpen.archivedInt ? 'open' : ''}`}
                    width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
              </div>
            </button>
            
            {accordionOpen.archivedInt && (
              <div className="lib-dash-acc-content">
                {renderJournalTable(internationalJournals2023)}
              </div>
            )}
          </div>
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default LibraryHolding;